module.exports = __webpack_public_path__ + "img/tender_icon.be54b138.svg";